import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProspectService } from 'src/app/service/prospect.service';
 

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  constructor(private router:Router ) {

   }

  ngOnInit() {
    let role=localStorage.getItem("currentRole");
    if(role.indexOf("admin")<0)
    this.router.navigate(['/login']   );

  }

}
